const Java = () => {
  return <h1>Java  </h1>;
};

export default Java;